<template>
  <div class="overflow-hidden text-left select-none" :style="{ '--duration': '200ms' }">
    <TransitionGroup name="list" tag="div" class="-mx-0.5 -my-1">
      <TagBase
        v-for="option in options"
        :size="size"
        :color="modelValue.includes(option.value) ? colors.selected : (isDisabled || modelValue.length >= max ? colors.disabled : colors.active)"
        class="cursor-pointer !justify-start text-left mx-0.5 my-1"
        :class="[
          (isDisabled && !modelValue.includes(option.value)) || (modelValue.length >= max && !modelValue.includes(option.value)) ? 'pointer-events-none' : ''
        ]"
        :key="option.value"
        @click="() => onSelect(option)"
      >
        {{ option.label }}
        
        <IconBase name="cute/check" :width="size === 'base' ? 12 : 14" class="ml-2" v-if="modelValue.includes(option.value)" />
      </TagBase>
    </TransitionGroup>
  </div>
</template>

<script lang="ts" setup>
interface Option {
  label: string
  value: string | number
}

const props = withDefaults(defineProps<{
  modelValue?: (string | number)[]
  options?: Option[]
  max?: number
  colors?: { selected: string, active: string, disabled: string }
  size?: 'base' | 'md' | 'sm' | 'lg'
  isDisabled?: boolean
}>(), {
	modelValue: () => [],
  max: 9999,
  options: () => [],
  colors: () => ({ selected: 'slate', active: 'gray', disabled: 'grayWeak' }),
  size: 'lg',
  isDisabled: false
})

const emit = defineEmits([ 'update:modelValue' ])

const onSelect = (option: Option) => {
  if (props.modelValue?.includes(option.value)) {
    emit('update:modelValue', props.modelValue.filter(v => v !== option.value))
  } else {
    emit('update:modelValue', [ ...(props.modelValue || []), option.value ].slice(0, props.max))
  }
}
</script>